import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import {
  CostsAndFeesContextProvider,
  useCostsAndFeesContext,
} from 'app/shared/modules/hdp/CostsAndFees/context/CostsAndFeesProvider';
import { SpecialOfferBanner } from './SpecialOfferBanner';
import { CostSummaryCard } from './CostSummaryCard';
import { LeaseTermsInline } from './LeaseTermsInline';
import { CostAndFeesFooter } from './CostAndFeesFooter';
import * as styles from './costAndFeesModule.styles';

const CostAndFeesContent = () => {
  const { calculatedCostsAndFees } = useCostsAndFeesContext();

  if (!calculatedCostsAndFees) return null;

  return <CostSummaryCard />;
};

export const CostAndFeesModule = () => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  if (!listing) return null;

  return (
    <div className={styles.container}>
      <SpecialOfferBanner />
      <CostsAndFeesContextProvider floorPlans={listing.floorplans as never}>
        <CostAndFeesContent />
      </CostsAndFeesContextProvider>
      <LeaseTermsInline />
      <CostAndFeesFooter />
    </div>
  );
};
